// extracted by mini-css-extract-plugin
module.exports = {"departments":"Pq-z","departmentHeading":"Qq-z","departmentSection":"Rq-z","departmentName":"Sq-z","departmentLink":"Tq-z","expandIcon":"Uq-z"};